// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__EP-PY","index":"styles_index__2UsmA"};